import * as React from 'react';
import { Theme } from '@emotion/react';
import { Typography } from 'bento';
import { calloutBase, calloutPadding, calloutVariant } from 'bento/Callout/calloutCssDefs';

export type CalloutVariant =
  | 'primary'
  | 'internal'
  | 'danger'
  | 'success'
  | 'subtle'
  | 'warning'
  | 'featureGate';

export interface CalloutProps extends Omit<React.HTMLProps<HTMLDivElement>, 'as'> {
  children: React.ReactNode;
  className?: string;
  disableTypography?: boolean;
  isDense?: boolean;
  variant?: CalloutVariant;
  as?: React.ElementType;
}

/**
 * Component used to render a short message on a colored background to
 * draw attention to the contents.
 * @deprecated Deprecated — no pantry replacement available yet.
 * Migration: No direct pantry mapping — please reach out to the Design Systems team on Slack (e.g., #pantry-design-system) for assistance with a pantry replacement.
 */
export const Callout: React.FunctionComponent<React.PropsWithChildren<CalloutProps>> = ({
  variant = 'primary',
  children,
  disableTypography,
  isDense = false,
  as: Component = 'section',
  ...rest
}) => {
  return (
    <Component
      css={(theme: Theme) => [
        calloutBase(theme),
        calloutVariant(theme, variant),
        calloutPadding(theme, isDense),
      ]}
      role="status"
      {...rest}
    >
      {disableTypography ? (
        children
      ) : (
        <Typography variant="body" component="p">
          {children}
        </Typography>
      )}
    </Component>
  );
};
